/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const licensedProfessionalMessages: SegmentSpecificMessages = {
  emailExplanation: "Use your work email if you have one",
  step: {
    personalInfo: {
      title: "Unlock this Special Offer",
      subtitle: "Verify you have a professional license in your field.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must hold a current professional license in your specified field. Eligible fields are shown in the Status selector of this form." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a licensed professional. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & other fields",
        subtitle: "Your information must match what is on your government-issued document(s).",
      },
      verifyingTitle: "Verifying your license",
      submitButtonText: "Verify My Licensed Professional Status",
    },
    docUpload: {
      title: "To continue, upload documents that confirm you are a licensed professional",
      uploadInstructions: "Upload a government-issued document that shows",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying licensed professionals.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
